export class BuyerSelectionReq {
    id: number;
    destination?: string;
    buyerGroup?: string;
    buyerSelect?: string;
    uniqueIdentifierSelection?: string;
    createdUser?: string;
    updatedUser?: string;

    constructor(
        id: number,
        destination?: string,
        buyerGroup?: string,
        buyerSelect?: string,
        uniqueIdentifierSelection?: string,
        createdUser?: string,
        updatedUser?: string,

    ) {
        this.id = id;
        this.destination = destination;
        this.buyerGroup = buyerGroup;
        this.buyerSelect = buyerSelect;
        this.uniqueIdentifierSelection = uniqueIdentifierSelection;
        this.createdUser = createdUser;
        this.updatedUser = updatedUser;

    }
}